import cntl from "cntl";
import PropTypes from "prop-types";
import { FeaturedIcon, ProgressBar } from "../atoms";
import { useMemo, useState, useCallback } from "react";
import { COLOR, FEATURED_ICON_VARIANTS, STATUS } from "../constants";
import { IconCircleCheck, IconTrash } from "@tabler/icons-react";

const propTypes = {
  icon: PropTypes.object,
  labelPB: PropTypes.string,
  className: PropTypes.string,
  progressPB: PropTypes.number,
  onRemoveFile: PropTypes.func,
  sizePB: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  status: PropTypes.oneOf([STATUS.success, STATUS.error, STATUS.undefined]),
};

function FileUploadItemBase({
  icon,
  status,
  sizePB,
  labelPB,
  className,
  progressPB,
  onRemoveFile,
}) {
  const [textStyle, setTextStyle] = useState("");
  const [iconStyle, setIconStyle] = useState("");
  const [statusStyle, setStatusStyle] = useState("");
  const [colorFeaturedIcon, setColorFeaturedIcon] = useState();

  const itemBaseWrappwerCn = () => cntl`
    p-4  
    flex
    border
    flex-row
    gap-x-3
    rounded-lg
    justify-between
    ${statusStyle}
    ${className ? className : undefined}
  `;

  const iconCn = () => cntl`
    h-4
    w-4
    shrink-0
    ${iconStyle}
  `;

  useMemo(() => {
    switch (status) {
      case STATUS.success:
        setTextStyle("text-primary-600");
        setIconStyle("text-primary-600");
        setColorFeaturedIcon(COLOR.primary);
        setStatusStyle("border-primary-500 bg-white");
        break;
      case STATUS.error:
        setTextStyle("text-error-600");
        setColorFeaturedIcon(COLOR.error);
        setIconStyle("text-error-600 cursor-pointer");
        setStatusStyle("border-error-300 bg-error-25");
        break;
      case STATUS.undefined:
        setTextStyle("text-primary-600");
        setColorFeaturedIcon(COLOR.primary);
        setStatusStyle("border-grey-200 bg-white");
        setIconStyle("text-grey-500 cursor-pointer");
        break;
      default:
        setTextStyle("text-primary-600");
        setColorFeaturedIcon(COLOR.primary);
        setStatusStyle("border-grey-200 bg-white");
        setIconStyle("text-grey-500 cursor-pointer");
        break;
    }
  }, [status]);

  const renderFeaturedIcon = useCallback(() => {
    return (
      <FeaturedIcon
        color={colorFeaturedIcon}
        vaiant={FEATURED_ICON_VARIANTS.light_circle_outline}
      >
        {icon}
      </FeaturedIcon>
    );
  }, [icon, colorFeaturedIcon]);

  return (
    <div className={itemBaseWrappwerCn()}>
      {renderFeaturedIcon()}
        <ProgressBar
          status={status}
          label={labelPB}
          textStyle={textStyle}
          sizeFile={sizePB?.toString()}
          progress={progressPB?.toString()}
        />
      {status === STATUS.success ? (
        <IconCircleCheck className={iconCn()} />
      ) : (
        <IconTrash className={iconCn()} onClick={() => onRemoveFile()} />
      )}
    </div>
  );
}

FileUploadItemBase.propTypes = propTypes;
export default FileUploadItemBase;
